import { Card, CardActionArea, CardMedia, Typography } from '@mui/material'

import { ArtistStoreCollectionBoxFragment } from '@/clients/utoniq-core/schema'
import { styleSets } from '@/components/styles'
import { config } from '@/config'
import { useRouter, useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'
import { useAnalytics } from '@/lib/analytics'

type ArtistStoreCollectionBoxProps = {
  collection: ArtistStoreCollectionBoxFragment
  width?: number
  /** analyticsクリックイベント時の導線名 */
  conductorName: string
}

export const ArtistStoreCollectionBox: Organism<ArtistStoreCollectionBoxProps> =
  ({ collection, width, conductorName }) => {
    const { t } = useTranslation('storeCollectionsSelect')
    const { generatePath, routerPages } = useRouter()
    const { analytics } = useAnalytics()
    const thumbnailUri =
      collection.thumbnail.mediumUri ?? collection.thumbnail.uri ?? ''

    return (
      <OrganismFrame>
        <Card elevation={0} sx={{ bgcolor: 'transparent', width }}>
          <CardActionArea
            href={generatePath(routerPages.StoreCollectionDetail, {
              artistId: collection.artistId,
              collectionId: collection.id,
            })}
            onClick={() => {
              analytics?.track('click_select', {
                applicationKey: config.applicationKey,
                artistId: collection.artistId,
                collectionId: collection.id,
                name: conductorName,
              })
            }}
          >
            <CardMedia
              component="img"
              height="90"
              image={thumbnailUri}
              sx={{ borderRadius: 1 }}
              alt={collection.title}
            />
            <Typography variant="subtitle1" sx={styleSets.lineCamp(1)}>
              {collection.title}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block' }}
            >
              {t('itemCount', { count: collection.publishedItemCount })}
            </Typography>
          </CardActionArea>
        </Card>
      </OrganismFrame>
    )
  }
